import { observer } from "mobx-react-lite";
import React from "react";

import "./CodeDetectionButton.scss";
import { translationService } from "../../../services/translation/TranslationService";
import { CodeDetection } from "../../../api-models/response/VideoAnalysisDataResponse";

export interface MainCodeButtonProps {
  codeDetection: CodeDetection;
  handleClick: (cd: CodeDetection) => void;
  isGroupCode?: boolean;
}

export default observer(function CodeDetectionButton(props: MainCodeButtonProps) {
  const { codeDetection, handleClick } = props;

  return (
    <div
      className={`code-detection ${
        codeDetection.isDetected ? (codeDetection.isVisible ? "active" : "inactive") : ""
      }`}
      key={codeDetection.code + codeDetection.colorCode}
      onClick={() => handleClick(codeDetection)}
      style={{
        backgroundColor: codeDetection.isDetected ? codeDetection.colorCode : "",
      }}
    >
      {props.isGroupCode
        ? translationService.translate(
            `damages.highlight-detection.${codeDetection.code.replace(/\s+/g, "-").toLowerCase()}`
          )
        : codeDetection.code}
      <div>{codeDetection.isDetected && codeDetection.isVisible ? "🗸" : ""}</div>
    </div>
  );
});
